import { HISTORY_ACTION_MODE, useEditor } from '@candulabs/craft';
import React from 'react';

import { DismissIconSettings } from 'craft/components/DismissIconSettings';
import { CRAFT_ROOT_ID } from 'craft/constants';
import { useGenerateInteractionLabelName } from 'craft/containers/Actions/useGenerateInteractionLabelName';
import { Section } from 'craft/containers/Toolbox/components';
import { useCraftPropsContext } from 'craft/contexts';
import { useMultiNodes } from 'craft/hooks';
import { Action, CATEGORIES, CssSelectorId, CustomNodeData } from 'craft/types';

export const OverlayDismiss = () => {
  const {
    isDismissible,
    actions: { setProps },
  } = useMultiNodes([CRAFT_ROOT_ID], (node) => ({ isDismissible: node?.data.props.isDismissible }));
  const { actions } = useEditor();
  const { documentId } = useCraftPropsContext();
  const generateInteractionLabelName = useGenerateInteractionLabelName([CRAFT_ROOT_ID]);

  const onToggleDismissible = () => {
    const newState = !isDismissible;
    setProps({ isDismissible: newState });
    // is dismissable, add an action
    actions.setCustom(
      CRAFT_ROOT_ID,
      (custom: CustomNodeData) => {
        if (newState) {
          // eslint-disable-next-line no-param-reassign
          custom.actions = [
            {
              category: CATEGORIES.DISMISS,
              eventName: generateInteractionLabelName('Dismiss', documentId.toString()),
            } as Action,
          ];
        } else {
          // eslint-disable-next-line no-param-reassign
          custom.actions = undefined;
        }
      },
      HISTORY_ACTION_MODE.MERGE,
    );
  };

  return (
    <Section name="Dismissible Overlay" isExpanded={isDismissible} onToggle={onToggleDismissible}>
      <DismissIconSettings
        nodeIds={[CRAFT_ROOT_ID]}
        dismissCssSelector={CssSelectorId.OverlayDismiss}
        dismissSVGCssSelector={CssSelectorId.OverlayDismissSVG}
      />
    </Section>
  );
};
